import {
    INITIAL_STATE,
    addRunningTimeEntryId,
    setRunningTimeEntryIds,
    removeRunningTimeEntryId,
} from '../core'
import {
    RESET_RUNNING_TIME_ENTRIES,
    ADD_RUNNING_TIME_ENTRY_ID,
    SET_RUNNING_TIME_ENTRY_IDS,
    REMOVE_RUNNING_TIME_ENTRY_ID,
    RECEIVE_TIME_ENTRY,
    CALCULATE_RUNNING_TIME_ENTRIES,
} from '../action_creators'

function runningTimeEntries(state=INITIAL_STATE.runningTimeEntries, action) {
    switch (action.type) {
        case ADD_RUNNING_TIME_ENTRY_ID:
            return addRunningTimeEntryId(state, action.userId, action.id)
        case SET_RUNNING_TIME_ENTRY_IDS:
            return setRunningTimeEntryIds(state, action.userId, action.ids)
        case REMOVE_RUNNING_TIME_ENTRY_ID:
            return removeRunningTimeEntryId(state, action.userId, action.id)
        case RECEIVE_TIME_ENTRY:
            return action.timeEntry.endAt
                ? removeRunningTimeEntryId(state, action.timeEntry.userId, action.timeEntry.id)
                : addRunningTimeEntryId(state, action.timeEntry.userId, action.timeEntry.id)
        case CALCULATE_RUNNING_TIME_ENTRIES: {
            const runningTimeEntriesObj = action.timeEntries.reduce((acc, c) => {
                const idsForUser = acc[c.userId] || []
                return {
                    ...acc,
                    [c.userId]: c.endAt ? idsForUser : [...idsForUser, c.id],
                }
            }, {})

            return runningTimeEntriesObj
        }
        case RESET_RUNNING_TIME_ENTRIES:
            return INITIAL_STATE.runningTimeEntries
        default:
            return state
    }
}

export default runningTimeEntries


// WEBPACK FOOTER //
// ./src/redux/reducers/running_time_entries_reducer.js